import { isOrangeMailHost } from "../superAdminRules";
import { Field, setField } from "../SuperAdminCommon";
import {
    btnBlackStyle,
    cardStyle,
    cardTitleStyle,
    errorStyle,
    inputStyle,
    orangeNoticeStyle,
    textareaStyle,
} from "../superAdminStyles";

function MailHint() {
    return (
        <p style={{ fontSize: "12px", color: "#9ca3af", marginTop: "12px", marginBottom: 0, display: "flex", alignItems: "flex-start", gap: "6px" }}>
            <span style={{ marginTop: "1px", flexShrink: 0 }}>ⓘ</span>
            Le mot de passe d'application est généré depuis le compte mail. Laissez le serveur IMAP vide pour utiliser{" "}
            <code style={{ background: "#f3f4f6", padding: "0 4px", borderRadius: "3px", fontSize: "11px" }}>imap.gmail.com</code>{" "}
            par défaut.
        </p>
    );
}

function IdentityFields({ form, setForm }) {
    return (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "16px", marginBottom: "16px" }}>
            <Field label="Nom *">
                <input style={inputStyle} placeholder="Pharmacie du Centre" value={form.name} onChange={setField(setForm, "name")} required />
            </Field>
            <Field label="Adresse">
                <input style={inputStyle} placeholder="8 av. de la Gare…" value={form.address} onChange={setField(setForm, "address")} />
            </Field>
            <Field label="Téléphone">
                <input style={inputStyle} placeholder="01 47 …" value={form.phone} onChange={setField(setForm, "phone")} />
            </Field>
            <Field label="Email (adresse mail IMAP)">
                <input style={inputStyle} type="email" placeholder="boite@gmail.com" value={form.email} onChange={setField(setForm, "email")} />
            </Field>
        </div>
    );
}

export function PharmacyCreateCard({ form, setForm, submitting, formError, onSubmit }) {
    return (
        <div style={cardStyle}>
            <h2 style={cardTitleStyle}>Ajouter une pharmacie</h2>
            <form onSubmit={onSubmit}>
                <IdentityFields form={form} setForm={setForm} />
                <div style={{ marginBottom: "16px" }}>
                    <Field label="Template" hint="optionnel">
                        <textarea
                            style={textareaStyle}
                            placeholder="Template spécifique à cette pharmacie…"
                            value={form.template}
                            onChange={setField(setForm, "template")}
                        />
                    </Field>
                </div>
                <div style={{ display: "flex", gap: "16px", alignItems: "flex-end" }}>
                    <div style={{ flex: 1 }}>
                        <Field label="Serveur IMAP">
                            <input style={inputStyle} list="mail-hosts" placeholder="imap.gmail.com" value={form.mailHost} onChange={setField(setForm, "mailHost")} />
                            <datalist id="mail-hosts">
                                <option value="imap.gmail.com" />
                                <option value="imap.orange.fr" />
                            </datalist>
                        </Field>
                    </div>
                    <div style={{ flex: 1 }}>
                        <Field label="Mot de passe d'application">
                            <input style={inputStyle} type="password" placeholder="•••• •••• •••• ••••" value={form.mailPassword} onChange={setField(setForm, "mailPassword")} autoComplete="new-password" />
                        </Field>
                    </div>
                    <button type="submit" disabled={submitting} style={btnBlackStyle}>
                        {submitting ? "Création..." : "Créer la pharmacie"}
                    </button>
                </div>
                {formError && <p style={errorStyle}>{formError}</p>}
                <MailHint />
                {isOrangeMailHost(form.mailHost) && (
                    <p style={orangeNoticeStyle}>
                        Orange : utilisez le mot de passe dédié aux logiciels de messagerie, sans espaces, et vérifiez que l’accès POP/IMAP est activé. Les messages sont relevés périodiquement, car Orange coupe les connexions IMAP longues.
                    </p>
                )}
            </form>
        </div>
    );
}
